import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const CategoryEdit = React.lazy(() => import("@mediaspace/features/category-edit"));

export const ManageContentTab = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/manage-content-tab/ManageContentTab")
);

export const PlaylistsTab = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/playlists-tab/PlaylistsTab")
);
export const DetailsTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/details-tab/DetailsTab"));
export const BrandingTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/branding-tab/BrandingTab"));
export const SettingsTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/settings-tab/SettingsTab"));
export const RoomTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/room-tab/RoomTab"));
export const RolesAndPermissionsTab = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/roles-and-permissions-tab/RolesAndPermissionsTab")
);
export const ContentModerationTab = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/content-moderation-tab/ContentModerationTab")
);
export const SubscribersTab = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/subscribers-tab/SubscribersTab")
);

// manage content actions
export const RemoveMenuItem = React.lazy(
    () =>
        import(
            "@mediaspace/features/category-edit/tabs/manage-content-tab/media-actions/remove-menu-item/RemoveMenuItem"
        )
);
export const DisplayInHeaderMenuItem = React.lazy(
    () =>
        import(
            "@mediaspace/features/category-edit/tabs/manage-content-tab/media-actions/display-in-header/DisplayInHeaderMenuItem"
        )
);
export const BulkRemoveButton = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/manage-content-tab/bulk-actions/bulk-remove/BulkRemoveButton")
);
export const BulkRemoveMenuItem = React.lazy(
    () =>
        import("@mediaspace/features/category-edit/tabs/manage-content-tab/bulk-actions/bulk-remove/BulkRemoveMenuItem")
);
export const InlineToggleField = React.lazy(() => import("@mediaspace/features/category-edit/tabs/InlineToggleField"));

// details tab fields
export const TitleField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/details-tab/details-fields/TitleField")
);
export const DescriptionField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/details-tab/details-fields/DescriptionField")
);
export const TagsField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/details-tab/details-fields/TagsField")
);
export const PrivacyField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/details-tab/details-fields/PrivacyField")
);

export const CollectionsField = React.lazy(
    () =>
        import("@mediaspace/features/category-edit/tabs/details-tab/details-fields/collections-field/CollectionsField")
);

// settings tab fields
export const SectionsField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/settings-tab/settings-fields/SectionsField")
);
export const DefaultTabField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/settings-tab/settings-fields/DefaultTabField")
);
export const ToggleField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/settings-tab/settings-fields/ToggleField")
);
export const HeaderLinksField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/settings-tab/settings-fields/HeaderLinksField")
);
export const LayoutField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/settings-tab/settings-fields/LayoutField")
);
export const ViewModeField = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/settings-tab/settings-fields/ViewModeField")
);

export const render = getDsLayoutComponentRenderer(CategoryEdit);
